module.exports = __webpack_public_path__ + "img/daurica1.cb2d4a6d.png";